import { QueryClient } from '@tanstack/react-query';

/**
 * TanStack Query client. Defaults lean offline-friendly:
 * - retry once (background sync handles mutation retries)
 * - staleTime of 30s keeps the UI snappy while we poll
 * - refetch on reconnect so returning from offline refreshes everything
 *
 * `networkMode: 'always'` is the load-bearing one, and it is not a tuning
 * choice. Query's default is `'online'`, which pauses anything it considers a
 * network call while `navigator.onLine` is false — but in this app queries and
 * mutations are reads and writes against *local SQLite*. The sync queue is the
 * only thing that talks to a server, and it has its own retry and its own
 * online trigger.
 *
 * Under the default, an inspector who lost signal got a "Saving…" button that
 * never resolved: the mutation was paused, so nothing was written locally and
 * nothing was queued, and the work only appeared if the radio came back before
 * they closed the app. That is the exact scenario this product exists for.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      networkMode: 'always',
    },
    mutations: {
      retry: 0,
      networkMode: 'always',
    },
  },
});
